<div class="container-integration__body col-xs-12 col-md-9 col-9 no-gutter">
    {{ 'words.stats' | translate }}
</div>
